import first from "lodash/first";
import { type FunctionComponent } from "react";

import { useSearchContext } from "scmp-app/components/search/contexts";
import { DropdownMenu } from "scmp-app/components/search/search-result-panel/components/dropdown-menu";
import type { hooksSectionMenuArticleSearchConnection$key } from "scmp-app/queries/__generated__/hooksSectionMenuArticleSearchConnection.graphql";

import { useSectionMenuOptions } from "./hooks";

type Props = {
  className?: string;
  reference: hooksSectionMenuArticleSearchConnection$key;
};

export const SectionMenu: FunctionComponent<Props> = ({ className, reference }) => {
  const { sectionIds, setSectionIds } = useSearchContext();
  const { options } = useSectionMenuOptions(reference);

  const selectedSectionOption = Array.isArray(sectionIds) ? (first(sectionIds) ?? "") : undefined;
  const isChangedOptionColor = selectedSectionOption !== "";

  return (
    <DropdownMenu
      className={className}
      isChangedOptionColor={isChangedOptionColor}
      onOptionSelect={sectionOption => {
        setSectionIds?.(sectionOption?.value ? [sectionOption.value] : []);
      }}
      options={options}
      placeholder="Section"
      selectedOptionValue={selectedSectionOption}
      withCount={!!options}
    />
  );
};

SectionMenu.displayName = "SectionMenu";
